import { Box, Link as MuiLink, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowForward } from '@mui/icons-material';

type MenusFullDetailsButtonProps = {
  close: () => void;
  catalogId: string;
};

const MenusFullDetailsButton = ({
  close,
  catalogId,
}: MenusFullDetailsButtonProps) => {
  const { t } = useTranslation();

  return (
    <Box display={'flex'} justifyContent={'flex-end'} mb={2}>
      <MuiLink
        sx={{ display: 'flex', alignItems: 'flex-end' }}
        component={Link}
        to={`../${catalogId}`}
        onClick={close}
        data-testid="MenusFullDetails.Button"
      >
        <Typography variant="body2">
          {t('drawer.menusDetailsDrawer.viewFullDetails')}
        </Typography>
        <ArrowForward sx={{ ml: 1 }} fontSize="small" />
      </MuiLink>
    </Box>
  );
};

export default MenusFullDetailsButton;
